let generation = 0;
let controller = new AbortController();
const listeners = new Set<() => void>();
const accessListeners = new Set<(key: string) => void>();
export function onApplicationAccessFailure(listener: (key: string) => void) {
  accessListeners.add(listener);
  return () => { accessListeners.delete(listener); };
}
export function reportApplicationAccessFailure(key: string) {
  for (const listener of accessListeners) listener(key);
}
export const getApplicationGeneration = () => generation;
export const getApplicationSignal = () => controller.signal;
export function resetApplicationRuntime() {
  generation += 1;
  const previous = controller;
  controller = new AbortController();
  previous.abort();
  for (const listener of listeners) { try { listener(); } catch { /* One observer cannot block a context change. */ } }
}
export function registerApplicationQueryClient(client: {cancelQueries: () => Promise<unknown>; clear: () => void}) {
  const reset = () => { void client.cancelQueries().catch(() => undefined); client.clear(); };
  listeners.add(reset);
  return () => { listeners.delete(reset); };
}
